export default __webpack_public_path__ + "static/media/ToeOff.03f519c9.png";